// src/assets/fileIcon.js
const fileIcon = {
  0: require('@/assets/type_dir.png'),
  1: require('@/assets/type_image.png'),
  2: require('@/assets/type_video.png'),
  3: require('@/assets/type_audio.png'),
  4: require('@/assets/type_txt.png'),
  5: require('@/assets/type_word.png'),
  6: require('@/assets/type_pdf.png'),
  7: require('@/assets/type_excel.png'),
  8: require('@/assets/type_zip.png'),
  9: require('@/assets/type_ppt.png'),
  100: require('@/assets/tab_doc_y.png'),
};

export default fileIcon;



// WEBPACK FOOTER //
// ./src/utils/file_icon.js